(function() {
  'use strict';

  /* --- Deck math: scroll progress -> (currentStep, transitionProgress) --- */
  var STEP_VH = 100;       /* each step's content holds for 100vh */
  var TRANS_VH = 50;       /* each hand-off has 50vh to play out */

  function computeDeckState(scrollProgress, n) {
    if (n <= 0) return { currentStep: 0, transitionProgress: 0, scrollProgress: 0 };
    if (n === 1) return { currentStep: 0, transitionProgress: 0, scrollProgress: 0 };
    var sp = Math.max(0, Math.min(1, scrollProgress));
    /* There is no transition after the final step. Keep this model aligned
       with the Liquid-calculated section height so scroll distance maps
       one-to-one to the visual hold and hand-off durations. */
    var total = n * STEP_VH + (n - 1) * TRANS_VH;
    var position = sp * total;
    var currentStep = n - 1;
    var trans = 0;

    for (var i = 0; i < n - 1; i++) {
      var stepStart = i * (STEP_VH + TRANS_VH);
      var transitionStart = stepStart + STEP_VH;
      var transitionEnd = transitionStart + TRANS_VH;
      if (position < transitionStart) {
        currentStep = i;
        break;
      }
      if (position < transitionEnd) {
        currentStep = i;
        trans = (position - transitionStart) / TRANS_VH;
        break;
      }
    }
    return { currentStep: currentStep, transitionProgress: trans, scrollProgress: sp };
  }

  /* --- Pool Story Scroll Logic ------------------------------------- */
  function initPoolStory() {
    var section = document.querySelector('.pool-story');
    if (!section) return;

    var deck            = section.querySelector('[data-deck]');
    var cards           = section.querySelectorAll('.pool-story__video-card');
    var robotIndicator  = section.querySelector('.pool-story__robot-indicator');
    var robot           = section.querySelector('.pool-story__indicator-robot');
    var dots            = section.querySelectorAll('.pool-story__indicator-dot');
    var steps           = section.querySelectorAll('.pool-story__step-content');

    if (!robotIndicator || !robot || !dots.length || !steps.length) return;

    /* Indicator constants (indicator track = 168px between dots)
       Dots at positions 0, 56, 112, 168 relative to track top
       Robot (48px) centered on active dot
    */
    function getSectionProgress() {
      var rect = section.getBoundingClientRect();
      var sectionHeight = rect.height;
      var vh = window.innerHeight;
      var scrolled = Math.max(0, -rect.top);
      var totalScrollable = sectionHeight - vh;
      if (totalScrollable <= 0) return 0;
      return Math.min(1, scrolled / totalScrollable);
    }

    function getZone(deckState, stepCount) {
      /* Change the narrative at the start of each media hand-off, keeping the
         text and the image deck in lockstep for any number of configured steps. */
      if (deckState.transitionProgress > 0 && deckState.currentStep < stepCount - 1) {
        return deckState.currentStep + 2;
      }
      return deckState.currentStep + 1;
    }

    function updateRobotIndicator(zone) {
      /* Robot moves from the first dot to the active dot. */
      /* Position robot centered on the active dot (48px between dots, robot 48px, dot 12px) */
      var activeIndex = zone - 1;
      var dotTop = activeIndex * 48; /* 0, 48, 96, 144 */
      /* Center robot (48px) on dot (12px): offset = (48-12)/2 = 18 */
      robot.style.top = (dotTop - 18) + 'px';

      /* Update dots */
      dots.forEach(function(dot) {
        var dotZone = parseInt(dot.getAttribute('data-zone'), 10);
        if (dotZone === zone) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    function showStep(zone) {
      steps.forEach(function(step) {
        var n = parseInt(step.getAttribute('data-step'), 10);
        if (n === zone) {
          step.classList.add('is-active');
        } else {
          step.classList.remove('is-active');
        }
      });
    }

    function hideAllSteps() {
      steps.forEach(function(step) {
        step.classList.remove('is-active');
      });
    }

    var slotBase = [
      { ty:   0, sc: 1.00, op: 1.00 },  /* slot 0  — front */
      { ty: -24, sc: 0.93, op: 0.75 },  /* slot 1  — behind 1 */
      { ty: -48, sc: 0.86, op: 0.50 },  /* slot 2  — behind 2 */
      { ty: -72, sc: 0.79, op: 0.25 }   /* slot 3  — behind 3 */
    ];
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
    var mobileActiveCard = -1;
    var mobilePrepared = false;

    function syncMobileNarrative() {
      var isMobile = MOBILE_MQ.matches;
      if (isMobile === mobilePrepared) return;

      cards.forEach(function(card, index) {
        card.removeAttribute('data-mobile-active');
        card.classList.remove('pool-story__video-card--ahead');
        card.style.transform = '';
        card.style.opacity = '';
        card.style.zIndex = '';
        card.style.pointerEvents = '';

        if (isMobile && steps[index]) {
          steps[index].after(card);
        } else if (deck) {
          deck.appendChild(card);
        }

        var video = card.querySelector('.pool-story__video');
        if (video) {
          video.controls = isMobile;
          if (isMobile) {
            try { video.pause(); } catch (e) {}
            video.preload = 'none';
          }
        }
      });

      mobilePrepared = isMobile;
      mobileActiveCard = -1;
    }

    function applyCardTransform(cardEl, offset) {
      var n = cards.length;
      var isMobile = MOBILE_MQ.matches;

      /* Hide cards whose offset is beyond the deck via a class (no inline display).
         On mobile the base rule already hides everything; --ahead only matters on desktop. */
      if (offset >= n) {
        cardEl.classList.add('pool-story__video-card--ahead');
      } else {
        cardEl.classList.remove('pool-story__video-card--ahead');
      }

      /* On mobile, CSS owns opacity via the [data-mobile-active] rule.
         Skip inline opacity writes there so the CSS rule wins. */
      function setOpacity(v) {
        if (!isMobile) cardEl.style.opacity = v;
      }

      if (offset >= n) return;

      /* --- Layer logic: current (front) card must stay on top of upcoming cards.
         Without this, the natural DOM order puts the upcoming card (later in DOM)
         above the current card, and the upcoming video visually covers the playing one.
         Key: |offset| closer to 0 = higher in stack. The current card is always |offset|=0;
         entering/upcoming cards have |offset| in 0..1 range; behind cards have larger |offset|.
         For the exiting card we use a very low z so the new front wins the overlap during
         the cross-fade. Multiply by 10 to keep the ordering stable across the full deck. */
      var layerZ = Math.round((1000 - Math.abs(offset) * 10));
      if (offset < 0) {
        /* Exiting card sinks behind everything; the entering card (same |offset|) wins
           via DOM order since it comes later in the document. */
        layerZ = 0;
      }
      cardEl.style.zIndex = String(layerZ);

      if (reduceMotion) {
        /* Snap to discrete slot — only opacity differences */
        var slotIdx = Math.max(0, Math.min(3, Math.round(offset)));
        if (slotIdx === 0) {
          cardEl.style.transform = 'translateY(0) scale(1)';
          setOpacity('1');
          cardEl.style.pointerEvents = 'auto';
        } else if (slotIdx >= n) {
          setOpacity('0');
          cardEl.style.pointerEvents = 'none';
        } else {
          cardEl.style.transform = 'translateY(' + slotBase[slotIdx].ty + 'px) scale(' + slotBase[slotIdx].sc + ')';
          setOpacity(String(slotBase[slotIdx].op));
          cardEl.style.pointerEvents = 'none';
        }
        return;
      }

      if (offset < 0 && offset >= -1) {
        /* Exit animation: continuous curve translateY 0 -> 100vh, scale 1 -> 0.79 over the full -1..0 window */
        var exit = -offset;
        cardEl.style.transform = 'translateY(' + (exit * 100) + 'vh) scale(' + (1 - 0.21 * exit) + ')';
        setOpacity(String(1 - exit));
        cardEl.style.pointerEvents = 'none';
        return;
      }
      if (offset < -1) {
        /* Already exited — keep off-screen at the exit-end position for reverse scroll */
        cardEl.style.transform = 'translateY(100vh) scale(0.79)';
        setOpacity('0');
        cardEl.style.pointerEvents = 'none';
        return;
      }

      /* 0..3 slot interpolation */
      var base  = Math.floor(offset);
      var frac  = offset - base;
      var upper = Math.min(base + 1, slotBase.length - 1);
      var a = slotBase[base];
      var b = slotBase[upper];
      var ty = a.ty + (b.ty - a.ty) * frac;
      var sc = a.sc + (b.sc - a.sc) * frac;
      var op = a.op + (b.op - a.op) * frac;
      cardEl.style.transform = 'translateY(' + ty + 'px) scale(' + sc + ')';
      setOpacity(String(op));
      /* Tiny dead-zone (0.05) to avoid flicker; spec ideal is offset === 0. */
      cardEl.style.pointerEvents = (offset < 0.05) ? 'auto' : 'none';
    }

    function applyDeck(deckState) {
      var cs  = deckState.currentStep;
      var tp  = deckState.transitionProgress;
      var n   = cards.length;
      if (n === 0) return;
      var frontIndex = Math.min(n - 1, Math.round(cs + tp));
      for (var i = 0; i < n; i++) {
        var offset = (i - cs) - tp;
        applyCardTransform(cards[i], offset);
      }
      return frontIndex;
    }

    function updateMobileActive(frontIndex) {
      if (!MOBILE_MQ.matches) {
        if (mobileActiveCard !== -1 && cards[mobileActiveCard]) {
          cards[mobileActiveCard].removeAttribute('data-mobile-active');
        }
        mobileActiveCard = -1;
        return;
      }
      if (mobileActiveCard !== -1 && mobileActiveCard !== frontIndex && cards[mobileActiveCard]) {
        cards[mobileActiveCard].removeAttribute('data-mobile-active');
      }
      if (frontIndex >= 0 && frontIndex < cards.length && cards[frontIndex]) {
        cards[frontIndex].setAttribute('data-mobile-active', 'true');
      }
      mobileActiveCard = frontIndex;
    }

    function update() {
      syncMobileNarrative();
      if (MOBILE_MQ.matches) {
        robotIndicator.classList.remove('is-visible');
        return;
      }

      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      /* Show when section is visible in viewport */
      var inView = rect.bottom > 0 && rect.top < vh;

      /* Check if pool-compare section is in view - hide indicator if so */
      var poolCompareSection = document.querySelector('[data-section-type="pool-compare"]');
      var poolCompareInView = false;
      if (poolCompareSection) {
        var pcRect = poolCompareSection.getBoundingClientRect();
        poolCompareInView = pcRect.top < vh && pcRect.bottom > 0;
      }

      var progress = getSectionProgress();
      var n = cards.length;
      var deckState = computeDeckState(progress, n);
      var frontIndex = applyDeck(deckState);
      updateMobileActive(frontIndex);
      syncActiveVideo(frontIndex, inView && !poolCompareInView, MOBILE_MQ.matches);

      if (inView && !poolCompareInView) {
        robotIndicator.classList.add('is-visible');
        var zone = getZone(deckState, n);
        updateRobotIndicator(zone);
        showStep(zone);
      } else {
        robotIndicator.classList.remove('is-visible');
        hideAllSteps();
      }
    }

    var activeIndex = -1;

    function getCardVideo(index) {
      if (index < 0 || index >= cards.length) return null;
      return cards[index].querySelector('.pool-story__video');
    }

    function syncActiveVideo(frontIndex, sectionInView, isMobile) {
      var newActive = -1;
      if (sectionInView && frontIndex >= 0 && frontIndex < cards.length) {
        newActive = frontIndex;
      }
      var newNext = (newActive >= 0 && cards.length > 0) ? (newActive + 1) % cards.length : -1;
      var oldNext = (activeIndex >= 0 && cards.length > 0) ? (activeIndex + 1) % cards.length : -1;
      if (newActive === activeIndex && newNext === oldNext) return;
      var oldActiveVideo = getCardVideo(activeIndex);
      var newActiveVideo = getCardVideo(newActive);
      var oldNextVideo = getCardVideo(oldNext);
      var newNextVideo = getCardVideo(newNext);
      if (oldActiveVideo) {
        try { oldActiveVideo.pause(); } catch (e) {}
        oldActiveVideo.preload = 'none';
      }
      if (newActiveVideo) {
        newActiveVideo.preload = 'metadata';
        try { newActiveVideo.play().catch(function() {}); } catch (e) {}
      }
      /* Warm the next-up video so the upcoming transition has metadata ready;
         demote the previous next-up when it falls out of the warm window. */
      if (oldNext !== newNext && oldNextVideo) {
        oldNextVideo.preload = 'none';
      }
      if (newNext !== newActive && newNextVideo) {
        newNextVideo.preload = 'metadata';
      }
      activeIndex = newActive;
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });

    /* Initial state */
    update();
    showStep(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPoolStory);
  } else {
    initPoolStory();
  }
})();
